// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_ResponsiveFacets.scss
// module id = 535
// module chunks = 1 2 4 5 6 7 8 13 88